<template>
  <div class="section">
    <div class="container">
      <h1>Questionnaires</h1>
      <div class="columns is-multiline">
        <div class="column is-5">
          <b-input v-model="filter" placeholder="Filter Questionnaires"></b-input>
        </div>
        <div class="column is-7">
          <b-button class="is-primary is-pulled-right" @click="openAddQuestionnaire">Add Questionnaire</b-button>
        </div>
        <div class="column is-12 is-hidden">
          <FiltersVue v-model="filters"></FiltersVue>
          <div class="breathe">
            <button class="button is-primary" @click="Refresh()">Get Questionnaires</button>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-table :data="filteredQuestionnaires"
                   hoverable
                   mobile-cards
                   paginated
                   :loading="loading"
                   :per-page="10"
                   pagination-simple>
            <b-table-column field="Period" label="Period" sortable v-slot="props">
              {{ props.row.Period }}
            </b-table-column>
            <b-table-column field="Entity" label="Country" sortable v-slot="props">
              <a @click="GotoScorecard(props.row.GroupId)">{{props.row.Entity}}</a>
            </b-table-column>
            <b-table-column field="Watchlist" width="30" sortable v-slot="props">
              <a id="watchlist-index" style="border: none;" href="javascript://" @click="goToCountryIndexNotices(props.row.GroupId)" v-show="props.row.Watchlist">
                <i class="fad fa-exclamation-triangle" v-tooltip="Tooltip($watchlist)"></i>
              </a>
            </b-table-column>
            <b-table-column field="Status" label="Status" sortable v-slot="props">
              <b-select v-model="props.row.Status" @input="updateQuestionnaire(props.row)">
                <option value="Open">Open</option>
                <option value="Closed">Closed</option>
              </b-select>
            </b-table-column>
            <b-table-column field="Score" label="Score" sortable v-slot="props">
              <a @click="Open(props.row)">{{ props.row.Score }}</a>
            </b-table-column>
            <b-table-column field="EnforceabilityScore" label="Enforceability" sortable v-slot="props">
              <a @click="OpenEnforceability(props.row)">{{ props.row.EnforceabilityScore }}</a>
            </b-table-column>
            <b-table-column field="QualifyingDeclarations" label="View Questionnaire" sortable v-slot="props">
              <a @click="goToQuestionnaire(props.row)">View</a>
            </b-table-column>
            <b-table-column field="exporting" label="Export PDF" v-slot="props">
              <button class="button is-default" :class="{'is-loading': props.row.exporting }" @click="Export(props.row)">Download</button>
              <div v-if="props.row.exporting" :key="props.row.Id">
                <export @complete="SetExporting(props.row, false)" :options="props.row.exportOptions"></export>
              </div>
            </b-table-column>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Role from '@/roles';
  import exportTool from '@/components/user/questionnaire/printQuestionnaire.vue';
  import scorecard from '@/components/modals/editScore.vue';
  import enforceability_scorecard from '@/components/modals/editEnforceabilityScore.vue';
  import addQuestionnaire from '@/components/modals/addQuestionnaire.vue';
  import FiltersVue from "@/services/components/Filters.vue";
  export default {
    components: {
      FiltersVue,
      "export": exportTool
    },
    data() {
      return {
        questionnaires: [],
        loading: false,
        filter: '',
        filters: []
      }
    },
    computed: {
      filteredQuestionnaires() {
        return this.questionnaires.filter((option) => {
          if (option.Entity.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
            return option
              .Entity
              .toString()
              .toLowerCase()
              .indexOf(this.filter.toLowerCase()) >= 0;
          } else if (option.Period.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
            return option
              .Period
              .toString()
              .toLowerCase()
              .indexOf(this.filter.toLowerCase()) >= 0;
          } else if (option.Status.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
            return option
              .Status
              .toString()
              .toLowerCase()
              .indexOf(this.filter.toLowerCase()) >= 0;
          }
        });
      }
    },
    methods: {
      goToCountryIndexNotices(id) {
        if (id == "a70fc607-1f3b-4957-8734-134da9cdfda0") {
          this.$router.push('/index/' + id + "#notices");
        }
        else if ((this.$store.getters.user && this.$store.getters.user.Groups && this.$store.getters.user.Groups.some((r) => r == id)) || (this.$store.getters.user && this.$store.getters.user.Roles && this.$store.getters.user.Roles.some((r) => r == Role.Admin || r == Role.Enhanced || r == Role.Standard || r == Role.AWGMember))) {
          this.$router.push('/index/' + id + "#notices");
        }
        else {
          this.$router.push('/restricted');
        }
      },
      Export(row) {
        row.exportOptions = { PeriodName: row.Period, CountryName: row.Entity, Status: row.Status, ClosedOn: row.ClosedOn, GroupId: row.GroupId, Id: row.Id };
        this.SetExporting(row, true);
      },
      SetExporting(row, bool) {
        row.exporting = bool;
        this.questionnaires = this.questionnaires.slice(0);
      },
      async updateQuestionnaire(q) {
        await this.$http.post("api/questionnaire/closeOrOpen", q)
          .then(async resp => {
            if (resp.data) {
              this.$buefy.toast.open({ message: "Questionnaire Saved!", type: 'is-success' });
            }
            else {
              this.$buefy.toast.open({
                duration: 5000,
                type: 'is-danger',
                message: "Failed to save the questionnaire. An error occurred."
              });
            }
          }).catch(err => {
            console.error(err);
            this.$buefy.toast.open({
              duration: 5000,
              type: 'is-danger',
              message: "Failed to save the questionnaire. An error occurred."
            });
          });
      },
      Refresh() {
        return this.$http.post("api/questionnaire/report", this.filters)
          .then(resp => {
            this.questionnaires = resp.data;
            this.loading = false;
            return resp.data;
          });
      },
      Open(questionnaire) {
        this.$buefy.modal.open({
          component: scorecard,
          props: {
            model: questionnaire
          },
          events: {
            close: () => { this.Refresh(); }
          }
        });
      },
      OpenEnforceability(questionnaire) {
        this.$buefy.modal.open({
          component: enforceability_scorecard,
          props: {
            questionnaire: questionnaire,
            model: questionnaire.Enforceability
          },
          events: {
            close: () => { this.Refresh(); }
          }
        });
      },
      openAddQuestionnaire() {
        this.$buefy.modal.open({
          component: addQuestionnaire,
          events: {
            close: () => { this.Refresh(); }
          }
        });
      },
      GotoScorecard(groupId) {
        this.$router.push('/index/' + groupId);
      },
      goToQuestionnaire(questionnaire) {
        this.$store.dispatch("setQuestionnaire", { GroupId: questionnaire.GroupId, Id: questionnaire.Id, CountryName: questionnaire.Entity, Status: questionnaire.Status, ClosedOn: questionnaire.ClosedOn });
        this.$router.push('/questionnaire/participation');
      },
      Tooltip(content) {
        return {
          autoHide: false,
          html: true,
          content: content
        }
      }
    },
    created() {
      this.loading = true;
      this.Refresh();
    }
  }
</script>
